(function (jQuery) {
  if (!jQuery || !jQuery.fn || !jQuery.fn.slick) return;

  jQuery(document).ready(function ($) {
    const MAX_VISIBLE_DOTS = 5;

    const slickOptions = {
      accessibility: false,
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4.2,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.6,
            slidesToScroll: 1,
          },
        },
      ],
    };

    function updatePagingInfo(slickInstance, currentSlide) {
      const $dots = slickInstance.$slider.find('.slick-dots li');
      const total = $dots.length;
      if (!total) {
        slickInstance.$slider.closest('.tab-content').find('.pagingInfo').text('');
        slickInstance.$slider.closest('.tab-contents').find('.pagingInfo').text('');
        return;
      }
      const activeIndex = $dots.filter('.slick-active').index();
      slickInstance.$slider
        .closest('.tab-content')
        .find('.pagingInfo')
        .text(`${activeIndex + 1}/${total}`);
      slickInstance.$slider
        .closest('.tab-contents')
        .find('.pagingInfo')
        .text(`${activeIndex + 1}/${total}`);
    }

    function limitVisibleDots(slickInstance) {
      if (!slickInstance.$dots) return;

      const $dots = slickInstance.$dots.find('li');
      const totalDots = $dots.length;
      const activeIndex = $dots.filter('.slick-active').index();

      let start = Math.max(0, activeIndex - Math.floor(MAX_VISIBLE_DOTS / 2));
      let end = Math.min(totalDots, start + MAX_VISIBLE_DOTS);

      if (end - start < MAX_VISIBLE_DOTS) {
        start = Math.max(0, end - MAX_VISIBLE_DOTS);
      }

      $dots.hide().slice(start, end).show();
    }

    function bindSliderEvents($slider) {
      $slider
        .on('init.newArrival reInit.newArrival', function (event, slickInstance) {
          updatePagingInfo(slickInstance, slickInstance.currentSlide);
          limitVisibleDots(slickInstance);
        })
        .on('afterChange.newArrival', function (event, slickInstance, currentSlide) {
          updatePagingInfo(slickInstance, currentSlide);
          limitVisibleDots(slickInstance);
        });
    }

    function initSlickIfNeeded($slider) {
      if (!$slider.length) return;
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('setPosition');
        return;
      }
      $slider.off('.newArrival');
      bindSliderEvents($slider);
      $slider.slick(slickOptions);
    }

    $('.new-arrival-sec').each(function () {
      const $section = $(this);
      const hasTabs = $section.find('.new-arrival-sec-tab .tab').length > 0;

      if (hasTabs) {
        $section.find('.tab').on('click', function (evt) {
          evt.preventDefault();

          $section.find('.tab').removeClass('active');
          $(this).addClass('active');

          $section.find('.tab-content').removeClass('active');
          const targetSelector = $(this).attr('data-toggles-target');
          if (!targetSelector) return;
          const $targetContent = $section.find(targetSelector);
          $targetContent.addClass('active');

          const $slider = $targetContent.find('.new-arrival-sec-pro-slider');
          $targetContent.find('.new-arrival-sec-pro-item').css('opacity', 0);

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              initSlickIfNeeded($slider);
              if ($slider.hasClass('slick-initialized')) {
                $slider.slick('slickGoTo', 0, false);
              }
              $targetContent.find('.new-arrival-sec-pro-item').css('opacity', 1);
              if ($slider.hasClass('slick-initialized')) {
                const slickInstance = $slider.slick('getSlick');
                updatePagingInfo(slickInstance, 0);
                limitVisibleDots(slickInstance);
              }
            });
          });
        });

        const $activeSlider = $section.find(
          '.tab-content.active .new-arrival-sec-pro-slider',
        );
        initSlickIfNeeded($activeSlider);
      } else {
        const $slider = $section.find('.new-arrival-sec-pro-slider').first();
        initSlickIfNeeded($slider);
      }
    });

    $('body').on('click', '.slick-arrow.slick-disabled', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    });

    $(window).on('load', function () {
      $('.new-arrival-sec .new-arrival-sec-pro-slider.slick-initialized').each(function () {
        $(this).slick('setPosition');
      });
    });
  });
})(window.__themeJQuery || window.jQuery);
